import { AxiosInstance, AxiosRequestConfig } from 'axios';

import helper from './helper';
import { MasterOutlet, MasterOutletUpdate, OutletHistoryItem } from './models/acb';
import { NewOutlet, OutletDistributor } from './models/outlet';
import {
  CreateMasterOutletPayload,
  CreateOutletPayload,
  MasterOutletUpdatePayload,
  RequestPayload,
  OutletSearchPayload,
  CreateUpdateOutletPayload,
  SubChannel,
  EditNewOutletPayload,
  SalesSourceUpdatePayload,
  SalesSource,
  CreateOutletDistributorPayload,
  UpdateOutletDistributorPayload,
} from './types';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getNewCount: () => 
    instance.get(
      'acb/outlet/count/', config),
  editNewOutlet: (payload: EditNewOutletPayload) => 
    instance.patch(
      'acb/outlet/edit/', payload, config),
  getNewOutlets: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', NewOutlet>>>(
      'acb/outlet/list/', payload, config),
  getNewOutlet: (id: number) =>
    instance.get<ApiResponse<NewOutlet>>(
      `acb/outlet/info/${id}/`, config),
  createNewOutlet: (payload: CreateOutletPayload) =>
    instance.post<ApiResponse<any>>(
      'acb/outlet/create/', payload, config),
  deleteNewOutlet: (id: number) =>
    instance.delete<ApiResponse<any>>(
      `acb/outlet/delete/${id}/`, config),
  getMasterOutlets: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', MasterOutlet>>>(
      'outlet/list/', payload, config),
  getMasterOutlet: (id: number) =>
    instance.get<ApiResponse<MasterOutlet>>(
      `outlet/info/${id}/`, config),
  createMasterOutlet: (payload: CreateMasterOutletPayload, send?: boolean) =>
    instance.post(
      `outlet/create/${send ? '?to_send=true' : ''}`,
      payload,
      config
    ),
  modifyMasterOutlet: (payload: CreateMasterOutletPayload, _?: boolean) =>
    instance.put(
      'outlet/update/', payload, config),

  getUpdateCount: () => instance.get('outlet/update_request/count/', config),
  createUpdate: (payload: CreateUpdateOutletPayload) => instance.post<ApiResponse<any>>('outlet/update_request/create/', payload, config),
  getUpdates: (payload: RequestPayload) => 
    instance.post<ApiResponse<Paginated<'data', MasterOutletUpdate>>>('outlet/update_request/list/', payload, config),
  saveUpdate: (payload: MasterOutletUpdatePayload) => instance.post('outlet/update_request/save/', payload, config),
  saveUpdateChannels: (payload: MasterOutletUpdatePayload) => instance.post('outlet/update_request/channels/save/', payload, config),
  modifyUpdate: (payload: MasterOutletUpdatePayload) => instance.post('outlet/update_request/update/', payload, config),
  modifyUpdateChannels: (payload: MasterOutletUpdatePayload) => instance.post('outlet/update_request/channels/update/', payload, config),
  modifyClose: (payload: { id: string }) => instance.post('outlet/update_request/close/', payload, config),

  searchOutlet: ({ search, distributor_id, attribute, status, limit, offset }: OutletSearchPayload) => 
    instance.get<ApiResponse<Paginated<'data', MasterOutlet>>>('autocomplete/outlet/' + helper.toQueryString({ search, distributor_id, limit, offset, status, attribute }), config),
  getHistory: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', OutletHistoryItem>>>('outlet/update_history/', payload, config),
  getOutletDistributors: (outletId: number, payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', OutletDistributor>>>(
      `outlet/distributors/list/${outletId}/`, payload, config),
  createOutletDistributor: (outletId: number, payload: CreateOutletDistributorPayload) =>
    instance.post<ApiResponse<OutletDistributor>>(
      `outlet/distributors/${outletId}/`, payload, config),
  updateOutletDistributor: (
    outletId: number,
    distributorId: number,
    payload: UpdateOutletDistributorPayload
  ) =>
    instance.patch<ApiResponse<OutletDistributor>>(
      `outlet/distributors/${outletId}/${distributorId}`, payload, config),

  // CHANNELS
  getChannels: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', SubChannel>>>('outlet/sub_channel/list/', payload, config),
  createChannel: (payload: SubChannel) => instance.post('outlet/sub_channel/create/', payload, config),
  updateChannel: (payload: SubChannel & { is_active: boolean } ) => instance.put('outlet/sub_channel/update/', payload, config),

  // ROUTES
  getRoutes: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', EntityBase>>>('outlet/route_number/list/', payload, config),
  createRoute: (payload: string) => instance.post('outlet/route_number/create/', { name: payload }, config),
  updateRoute: (payload: EntityBase & { is_active: boolean } ) => instance.put('outlet/route_number/update/', payload, config),
  getRoute: (id: number) => instance.get<ApiResponse<EntityBase>>(`outlet/route_number/info/${id}/`, config),
  // searchRoutes: ({ search }: { search: string }) => 
  //   instance.get<ApiResponse<Paginated<'data', MasterOutlet>>>('autocomplete/route_number/' + helper.toQueryString({ search }), config),

  // SALES SOURCES
  getSalesSources: (outlet_id: number) => instance.get<ApiResponse<SalesSource[]>>(`outlet/sales_source/${outlet_id}/get`, config),
  updateSalesSource: (payload: SalesSourceUpdatePayload) => instance.post('outlet/sales_source/save/', payload, config),

});
